import { getUrl, Post, Get, Put, Patch } from ".";

// export const List = async (body) => {
//   return Post(getUrl('cnps.css.merchant-owner.search'), body);
// }

export const List = async (body) => {
  return Post(getUrl('cnps.css.merchant-owner.filter'), body);
}

export const GetCount = async (body) => {
  return Post(getUrl('cnps.css.merchant-owner.count-status'), body);
}
export const GetList = async (body) => {
  return Post(getUrl('cnps.css.merchant-owner.get-list'), body);
}

export const Create = async (body) => {
  return Post(getUrl('cnps.css.merchant-owner.create'), body);
}

export const Detail = async (id) => {
  return Get(getUrl('cnps.css.merchant-owner.get', { id }));
}

export const Update = async (id, body) => {
  return Put(getUrl('cnps.css.merchant-owner.update', { id }), body);
}

export const UpdateStatus = async (id, body) => {
  return Patch(getUrl('cnps.css.merchant-owner.update-status', { id }), body);
}
